export { default } from './BloodTypeModalContent';
